import React from "react";
import { useTranslation } from "react-i18next";

const PlaceholderComponent = ({ title, ...props }) => {
  const { t } = useTranslation();

  const renderSpinner = (spinner) => {
    return (
      <div className="mr-8">{spinner && <viedoc-spinner></viedoc-spinner>}</div>
    );
  };

  const renderProcessingTextLabel = () => {
    return (
      <>
        <p className="f15">
          {t("ARCHIVE.TEXT_PROCESSING")} {props.processValue || 0}%
        </p>
        <div
          disabled={props.processValue <= 0}
          className="close-button-placeholder"
          onClick={() => {
            props.setShowPlaceholderComponent(false);
            props.cancelHandler();
          }}
          title={t("ARCHIVE.BUTTON_CANCELBTN")}
        >
          <viedoc-icon name="close" />
        </div>
      </>
    );
  };

  return (
    <div className="placeholder-component">
      {renderSpinner(props.topSpinner)}
      <div className="f21 dark-grey">{title}</div>
      <p className="f16 light-grey">{props.subTitle}</p>
      <div className="d-flex align-center mr-8 jc-space-evently">
        {renderSpinner(props.bottomSpinner)}
        {props.loader && renderProcessingTextLabel()}
      </div>
    </div>
  );
};

export default PlaceholderComponent;
